import { Component } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap';

export default class TopNav extends Component {
  componentDidMount() {
    const dropdowns = document.querySelectorAll('.nav-item.dropdown');

    dropdowns.forEach(dropdown => {
      const menu = dropdown.querySelector('.dropdown-menu');
      const toggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');
      const icon = dropdown.querySelector('i');

      dropdown.addEventListener('mouseenter', () => {
        const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(toggle);
        dropdownInstance.show();
        if (icon) icon.classList.replace('bi-chevron-down', 'bi-chevron-up');
      });

      dropdown.addEventListener('mouseleave', () => {
        const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(toggle);
        dropdownInstance.hide();
        if (icon) icon.classList.replace('bi-chevron-up', 'bi-chevron-down');
      });
    });
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm d-flex align-items-center" style={{ height: "100px", zIndex: 1000 }}>
        <div className="container-fluid d-flex justify-content-between align-items-center px-100px">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img src="/bhepl_logo.webp" alt="My App Logo" className="app-logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse justify-content-end bg-white" id="navbarContent">
            <ul className="navbar-nav">
              <li className="nav-item mx-2">
                <a className="nav-link text-black pb-1 px-0" href="/about">Our Company</a>
              </li>

              <li className="nav-item dropdown mx-2 d-flex align-items-center nav-link px-0 pb-1">
                <div className="dropdown-wrapper position-relative">
                  <a
                    className="text-decoration-none text-black px-0"
                    style={{ outline: 'none', cursor: 'pointer' }}
                    href="/solutions"
                    id="caseStudiesDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Products & Solutions<i className="bi bi-chevron-down ms-2" style={{ fontSize: '12px' }}></i>
                  </a>

                  <div
                    className="dropdown-menu shadow-lg border rounded"
                    aria-labelledby="caseStudiesDropdown"
                    style={{
                      position: 'fixed', // Changed from default to fixed
                      left: '50%',
                      top: 'calc(33% + 40px)', // Center vertically
                      transform: 'translate(-50%, -50%)', // Adjust for both X and Y
                      width: '90vw',
                      maxWidth: '1200px', // Optional: add max-width for better appearance
                      borderColor: '#B297FF',
                      borderWidth: '2px',
                      zIndex: 1000, // Ensure it appears above other content
                    }}
                  >
                    <div className="px-4 py-4">
                      <a href="/solutions" className="text-primary-blue fw-semibold fs-24 text-decoration-none ps-1 text-black-primary">Products & Solutions</a>
                      <div className="row ps-3 mt-4 pt-1">
                        <div className="col-md-5 ps-0">
                          <label className="text-primary-blue border-3 fs-22">Advanced Train Collision Avoidance Systems</label>
                          <ul className="list-unstyled mt-2">
                            <li className="mt-2">
                              {/* <a href="/solutions/products" className="fs-18 text-decoration-none text-black-primary">EULYNX Protocol Box</a> */}
                              <a href="#" className="fs-18 text-decoration-none text-muted" style={{ cursor: "default" }}>EULYNX Protocol Box</a>
                            </li>
                            <li className="mt-2">
                              <a href="#" className="fs-18 text-decoration-none text-muted" style={{ cursor: "default" }}>Design Document Automation</a>
                            </li>
                          </ul>
                        </div>

                        <div className="col-md-3 px-0">
                          <label className="text-primary-blue fs-22 border-3 border-start px-md-4 ms-md-2 mt-md-0 mt-3">Smart Yard Solutions</label>
                          <li className="mt-2">
                            <a href="#" className="fs-18 text-decoration-none text-black px-md-4 ms-md-2 text-muted" style={{ cursor: "default" }}>Safety management</a>
                          </li>
                          <li className="mt-2">
                            <a href="#" className="fs-18 text-decoration-none text-black px-md-4 ms-md-2 text-muted" style={{ cursor: "default" }}>Asset management</a>
                          </li>
                        </div>

                        <div className="col-md-4 px-0">
                          <label className="text-primary-blue fs-22 border-3 border-start px-md-4 mt-md-0 mt-3" style={{ cursor: "default" }}>Operations & Maintenance</label>
                          <ul className="list-unstyled mt-2">
                            <li className="mt-2">
                              <a href="#" className="fs-18 text-decoration-none text-black px-md-4 text-muted" style={{ cursor: "default" }}>Metro Corridors</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </li>




              <li className="nav-item mx-2">
                <a className="nav-link text-black pb-1 px-0" href="/case-studies">Case Studies</a>
              </li>
              <li className="nav-item mx-2">
                <a className="nav-link text-black pb-1 px-0" href="/innovation">Innovation</a>
              </li>
              <li className="nav-item mx-2">
                <a className="nav-link text-black pb-1 px-0" href="/career">Careers</a>
              </li>
              <li className="nav-item mx-2">
                <a className="nav-link text-black pb-1 px-0" href="/contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
